import { view } from '@esui/core';
import { DemoPage, Section } from '../@demo/utils.js';
import { Icon } from './index.js';

export const [IconDemo] = view('icon-demo', {
  template() {
    return DemoPage(
      Section(
        '',
        Icon('sentiment_very_dissatisfied'),
        Icon('sentiment_dissatisfied'),
        Icon('sentiment_neutral'),
        Icon('sentiment_satisfied'),
        Icon('sentiment_very_satisfied')
      ),

      Section(
        'Color and size',
        Icon('all_out'),
        Icon('accessibility'),
        Icon('exit_to_app'),
        Icon('camera')
      )
        .color('tomato')
        .style('--mdc-icon-size', '4em')
    );
  },
});
